import { render, staticRenderFns } from "./PartnerCreation.vue?vue&type=template&id=8fa36bde&scoped=true&"
import script from "./PartnerCreation.vue?vue&type=script&lang=js&"
export * from "./PartnerCreation.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCreation.vue?vue&type=style&index=0&id=8fa36bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa36bde",
  null
  
)

export default component.exports